import { useState } from "react";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { AddressCard } from "../../molecules/addressCard/AddressCard";
import style from "./pickupLocation.module.scss";
import { Icon } from "../../icon/Icon";
import { usePickupLocation } from "../../../hooks/usePickupLocation/UsePickupLocation";
import { AddressModal } from "../../molecules/addressModal/AddressModal";
import { CustomModal } from "../../molecules/cutomModal/CustomModal";
import { MapView } from "../../molecules/mapView/MapView";
import { AgentScript } from "../../atoms/agentScript/AgentScript";
import { Flex } from "antd";
interface PickupLocationProps {
  selectedAddress: any;
  setSelectedAddress: any;
  handleAddressSelection: any;
}

export const PickupLocation: React.FC<PickupLocationProps> = ({
  selectedAddress,
  setSelectedAddress,
  handleAddressSelection,
}) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const {
    formattedAddress,
    isOpen,
    handleCancel,
    address1,
    address2,
    setAddress2,
    setAddress1,
    landmark,
    setLandmark,
    ambulanceAvailable,
    setAmbulanceAvailable,
    liftAvailable,
    setLiftAvailable,
    autocompleteSuggestions,
    handleInputChange,
    handleSuggestionClick,
    saveAddress,
    handleOpenModal,
    CurrentLocation,
    detectedLocation,
    patientLocation,
  } = usePickupLocation({ handleAddressSelection });

  const hasCoordinates = CurrentLocation?.[0]?.geoLocation?.coordinates?.length > 0;
  const hasValidPatientLocation = Boolean(
    (selectedAddress?.geoLocation?.coordinates?.length > 0 || selectedAddress?.location?.latitude || selectedAddress?.location?.longitude || selectedAddress?.location?.coordinates?.length > 0) ||
    (patientLocation?.geoLocation?.coordinates?.length > 0 || patientLocation?.location?.latitude || patientLocation?.location?.longitude) ||
    (detectedLocation?.geoLocation?.coordinates?.length > 0) ||
    hasCoordinates
  );

  const scriptText = hasCoordinates
    ? "Our system shows that the patient is at  <Location>, Can you please confirm if the patient is at this location?"
    : "\u201cOur system couldn\u2019t detect your current location. From your saved locations, I can see the following options. Please help me choose the correct one. Alternatively, you can add a new location also\u201d";

  return (
    <BackgroundWrapper className={style.background}>
      <Container>
        <Flex className={style.labelRow}>
          <Text text="Select Pickup Location" className={style.title} />
          <AgentScript
            text={scriptText}
            className={style.mobileOnly}
          />
        </Flex>
        <AgentScript
          text={scriptText}
          className={style.desktopOnly}
        />
        <Flex justify="space-between" align="center" className={style.space}>
          <Text text={hasCoordinates ? "Live Location" : "Requested Location"} className={style.address_title} />
          {hasValidPatientLocation && (
            <button onClick={() => setIsMapModalOpen(true)} className={style.button}>See Map View</button>
          )}
        </Flex>
      </Container>
      <Container className={style.address_wrapper}>
        <div>
          <Container className={style.addressCard}>
            {CurrentLocation.map((address: any, index: number) => (
              hasCoordinates ? (
                <AddressCard
                  key={index + 1}
                  leftSideIcon="/images/home.png"
                  rightSideBadgeText={["LiveLocation"]}
                  address={address}
                  handleAddressSelection={handleAddressSelection}
                  selectedAddress={selectedAddress}
                />
              ) : (
                <div key={index + 1} className={style.addressCard}>
                  <Text text={`${address?.city || ''}${address?.state ? ', ' + address.state : ''}`} className={style.question} />
                </div>
              )
            ))}
          </Container>
          <AgentScript
              text="If incorrect: No problem, please help me with the correct address or location."
              className={style.desktopOnly}
            />
          <Flex className={style.labelRow}>
            <Container className={style.card}>
              <div onClick={handleOpenModal} className={style.icon}>
                <Icon className={style.icon_prop} src="/images/plus.png" alt="Plus Icon" />
                <Text className={style.btn} text="Add New Location" />
              </div>
            </Container>
            <AgentScript
              text="If incorrect: No problem, please help me with the correct address or location."
              className={style.mobileOnly}
            />
          </Flex>
        </div>
        <Container>
          {(formattedAddress ?? []).length > 0 && (
            <>
              <Text text="Saved Address" className={style.address_title} />
              <Container className={style.addressCard}>
                {formattedAddress!.map((address: any, index: number) => (
                  <AddressCard
                    key={index + 1}
                    leftSideIcon="/images/home.png"
                    rightSideBadgeText={["Saved"]}
                    address={address}
                    handleAddressSelection={handleAddressSelection}
                    selectedAddress={selectedAddress}
                  />
                ))}
              </Container>
            </>
          )}
        </Container>

        {isOpen && <AddressModal
          isOpen={isOpen}
          onClose={handleCancel}
          address1={address1}
          setAddress1={setAddress1}
          address2={address2}
          setAddress2={setAddress2}
          landmark={landmark}
          setLandmark={setLandmark}
          ambulanceAvailable={ambulanceAvailable}
          setAmbulanceAvailable={setAmbulanceAvailable}
          liftAvailable={liftAvailable}
          setLiftAvailable={setLiftAvailable}
          autocompleteSuggestions={autocompleteSuggestions}
          handleInputChange={handleInputChange}
          handleSuggestionClick={handleSuggestionClick}
          saveAddress={saveAddress}
        />}

        {isMapModalOpen && (
          <CustomModal
            modalTitle="Map View"
            isModalOpen={isMapModalOpen}
            isCloseModal={() => setIsMapModalOpen(false)}
          >
            <MapView addressSelected={selectedAddress || patientLocation || detectedLocation || CurrentLocation?.[0] || formattedAddress?.[0]} />
          </CustomModal>
        )}
      </Container>
    </BackgroundWrapper>
  );
};
